import React from 'react';
import { CaptureConsole } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { HTTPError } from 'common/utils/error.util';
import { ENV_IS_PROD } from '../constants/env.constants';

const integrations: Sentry.BrowserOptions['integrations'] = [
  new Sentry.BrowserTracing({
    routingInstrumentation: Sentry.reactRouterV6Instrumentation(
      React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    ),
  }),
  new CaptureConsole({ levels: ['error'] }),
];

if (Number(process.env.REACT_APP_SENTRY_REPLAY_ENABLED) === 1) {
  integrations.push(new Sentry.Replay());
}

// eslint-disable-next-line no-console
console.log(`Environment: ${process.env.REACT_APP_ENV_NAME}, release ${process.env.REACT_APP_CI_RELEASE}`);

if (ENV_IS_PROD) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_CI_RELEASE,
    environment: process.env.REACT_APP_ENV_NAME?.replaceAll('/', '-'),
    integrations,
    tracesSampleRate: 0.3,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
    beforeSend: (event, hint) => {
      const exception = hint.originalException;
      const newEvent = { ...event };
      if (exception instanceof HTTPError) {
        newEvent.fingerprint = ['{{ default }}', exception.method!, exception.url!];
      }

      return newEvent;
    },
  })
};
